/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListOrganizationUsersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOrganizationUsersRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListOrganizationUsersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUsersSecurity$outboundSchema: z.ZodMiniType<
  ListOrganizationUsersSecurity$Outbound,
  ListOrganizationUsersSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listOrganizationUsersSecurityToJSON(
  listOrganizationUsersSecurity: ListOrganizationUsersSecurity,
): string {
  return JSON.stringify(
    ListOrganizationUsersSecurity$outboundSchema.parse(
      listOrganizationUsersSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationUsersRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUsersRequest$outboundSchema: z.ZodMiniType<
  ListOrganizationUsersRequest$Outbound,
  ListOrganizationUsersRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listOrganizationUsersRequestToJSON(
  listOrganizationUsersRequest: ListOrganizationUsersRequest,
): string {
  return JSON.stringify(
    ListOrganizationUsersRequest$outboundSchema.parse(
      listOrganizationUsersRequest,
    ),
  );
}
